import { connect } from 'react-redux';
import { datePageNext, datePagePrev, selectDate, saveSliderPosition, setExtraLife, setExtraLifeAutoComplete } from '../../actions/date';
import { goToRoute, tryNavigateTo } from '../../actions/navigation';
import { tryResetApp } from '../../actions/index';
import { AppStep } from '../../reducers/navigation';
import DateSelection from './DateSelection';
import { isModal } from '../../routesMap';
import { disableUsedBookingLocalStorage } from '../../actions/bookingLocation';


const mapStateToProps = state => ({
  availableDates: state.date.futureAvailabilityData,
  bookingLocation: state.bookingLocation.selectedLocation,
  pageNum: state.date.selectedDatePage,
  navPath: state.navigation.navPath,
  navigation: state.navigation,
  initialSliderPosition: state.date.lastSliderPosition,
  languageObj: state.language.date_selection_js,
  isExtraLife: state.date.isExtraLife,

  //variable for automation via calendar link
  usedBookingLocalStorage: state.bookingLocation.usedBookingLocalStorage,
  selectedDate: state.date.selectedDate
});

const mapDispatchToProps = dispatch => ({
  selectDate: date => dispatch(selectDate(date)),
  nextDatePage: () => dispatch(datePageNext()),
  prevDatePage: () => dispatch(datePagePrev()),
  proceedSequence: () => dispatch(tryNavigateTo(AppStep.Sequence)),
  proceedExtraLife: () => dispatch(tryNavigateTo(AppStep.Sequence)),
  transitionBack: () => dispatch(tryNavigateTo(AppStep.Location)),
  transitionForward: () => {
    if (!isModal) dispatch(goToRoute(AppStep.Sequence));
    else dispatch(tryNavigateTo(AppStep.Sequence));
  },
  saveSliderPosition: sliderPosition => dispatch(saveSliderPosition(sliderPosition)),
  toggleExtraLife: () => dispatch(setExtraLife()),
  resetApp: () => dispatch(tryResetApp()),

  //automation via calendar link disabler (if they go back)
  disableUsedBookingLocalStorage: () => dispatch(disableUsedBookingLocalStorage()),

  //automation via extra life
  setExtraLifeAutoComplete: (toggleState) => dispatch(setExtraLifeAutoComplete(toggleState))
});

export default connect(mapStateToProps, mapDispatchToProps)(DateSelection);
